var _rect, _g, _path, _path2, _path3, _path4, _path5, _line, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g2, _path6, _path7, _path8, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAirError = function SvgAirError(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 146,
    viewBox: "0 0 130 146",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.695068,
    y: 54.3408,
    width: 108.681,
    height: 54.9467,
    rx: 6.8951,
    transform: "rotate(-30 0.695068 54.3408)",
    fill: "#E7E7E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_47299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.553 79.9115L33.3025 78.9015L33.3834 68.9412L38.1944 66.1635C38.9204 65.7444 39.1681 64.8199 38.749 64.0939C38.3298 63.3679 37.4054 63.1202 36.6793 63.5393L31.8683 66.317L23.202 61.4069L21.4525 62.417L27.9321 68.5896L23.1211 71.3672L20.5464 69.9379L19.2343 70.6955L22.1291 73.6894L23.2745 77.6933L24.5866 76.9358L24.6361 73.9914L29.4471 71.2138L31.553 79.9115Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.342 23.4799L98.813 24.2956L85.1672 32.1739L84.6963 31.3582L98.342 23.4799ZM86.5691 34.6021L100.215 26.7237L99.273 25.0923L85.6272 32.9707L86.5691 34.6021ZM100.675 27.5204L101.146 28.3361L87.5001 36.2145L87.0291 35.3988L100.675 27.5204ZM101.617 29.1518L102.077 29.9486L88.431 37.827L87.971 37.0302L101.617 29.1518ZM103.479 32.3767L103.019 31.58L89.3729 39.4584L90.3038 41.0708L103.95 33.1924L103.479 32.3767Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.908 41.7812L108.441 40.9723L94.7954 48.8507L95.2624 49.6596L108.908 41.7812ZM93.4051 46.4426L107.051 38.5642L107.985 40.1821L94.3392 48.0605L93.4051 46.4426ZM106.595 37.7741L106.128 36.9651L92.4818 44.8435L92.9489 45.6524L106.595 37.7741ZM105.661 36.1561L105.204 35.366L91.5586 43.2444L92.0148 44.0345L105.661 36.1561ZM103.814 32.9579L104.27 33.7481L90.6245 41.6264L89.7012 40.0273L103.347 32.149L103.814 32.9579Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7588 24.2022L98.2878 23.3865L84.6421 31.2649L85.113 32.0806L98.7588 24.2022ZM83.2402 28.8367L96.886 20.9584L97.8278 22.5898L84.1821 30.4682L83.2402 28.8367ZM96.426 20.1616L95.955 19.3459L82.3093 27.2243L82.7802 28.04L96.426 20.1616ZM95.4841 18.5302L95.0241 17.7335L81.3783 25.6119L81.8383 26.4086L95.4841 18.5302ZM93.6222 15.3053L94.0822 16.1021L80.4364 23.9805L79.5055 22.368L93.1512 14.4896L93.6222 15.3053Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14262 60.3121C2.23859 57.0142 3.36852 52.7972 6.6664 50.8932L88.8445 3.44768C92.1423 1.54366 96.3593 2.67358 98.2633 5.97146L98.654 6.64806L4.53325 60.9887L4.14262 60.3121Z",
    fill: "#FB8400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7207 95.9546C26.6247 99.2525 30.8417 100.382 34.1395 98.4784L116.318 51.0329C119.615 49.1289 120.745 44.9119 118.841 41.614L118.451 40.9374L24.33 95.278L24.7207 95.9546Z",
    fill: "#FB8400"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.7221,
    y1: 16.2199,
    x2: 94.1955,
    y2: 63.8052,
    stroke: "#BFBFBF",
    strokeWidth: 1.37902,
    strokeDasharray: "5.17 5.17"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8457,
    y: 49.4879,
    width: 29.0894,
    height: 4.0402,
    transform: "rotate(-30 43.8457 49.4879)",
    fill: "#FB8400"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3962,
    y: 50.9018,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(60 41.3962 50.9018)",
    fill: "#FB8400"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4368,
    y: 57.8998,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(60 45.4368 57.8998)",
    fill: "#FB8400"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4768,
    y: 64.8978,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(60 49.4768 64.8978)",
    fill: "#FB8400"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.886,
    y: 56.4858,
    width: 29.0894,
    height: 4.0402,
    transform: "rotate(-30 47.886 56.4858)",
    fill: "#FB8400"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51.926,
    y: 63.4835,
    width: 29.0894,
    height: 4.0402,
    transform: "rotate(-30 51.926 63.4835)",
    fill: "#FB8400"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_135_47299)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.6238,
    y: 54.3408,
    width: 108.681,
    height: 54.9467,
    rx: 6.8951,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5617 91.9139L29.5818 91.9139L34.6321 83.3285L40.1873 83.3285C41.0257 83.3285 41.7024 82.6518 41.7024 81.8134C41.7024 80.9751 41.0257 80.2984 40.1873 80.2984L34.6321 80.2984L29.5818 71.713L27.5617 71.713L30.0868 80.2984L24.5316 80.2984L23.0165 77.7732L21.5014 77.7732L22.5115 81.8134L21.5014 85.8536L23.0165 85.8536L24.5316 83.3285L30.0868 83.3285L27.5617 91.9139Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.618 76.4379L113.618 77.3798L97.8616 77.3798L97.8616 76.4379L113.618 76.4379ZM97.8616 80.1835L113.618 80.1835L113.618 78.2997L97.8616 78.2997L97.8616 80.1835ZM113.618 81.1035L113.618 82.0454L97.8616 82.0454L97.8616 81.1035L113.618 81.1035ZM113.618 82.9873L113.618 83.9073L97.8616 83.9073L97.8616 82.9873L113.618 82.9873ZM113.618 86.7111L113.618 85.7911L97.8616 85.7911L97.8616 87.653L113.618 87.653L113.618 86.7111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.618 97.5707L113.618 96.6366L97.8616 96.6366L97.8616 97.5707L113.618 97.5707ZM97.8616 93.856L113.618 93.856L113.618 95.7242L97.8616 95.7242L97.8616 93.856ZM113.618 92.9436L113.618 92.0095L97.8616 92.0095L97.8616 92.9436L113.618 92.9436ZM113.618 91.0754L113.618 90.163L97.8616 90.163L97.8616 91.0754L113.618 91.0754ZM113.618 87.3824L113.618 88.2948L97.8616 88.2948L97.8616 86.4483L113.618 86.4483L113.618 87.3824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.618 77.2715L113.618 76.3297L97.8616 76.3297L97.8616 77.2715L113.618 77.2715ZM97.8616 73.5259L113.618 73.5259L113.618 75.4097L97.8616 75.4097L97.8616 73.5259ZM113.618 72.6059L113.618 71.664L97.8616 71.664L97.8616 72.6059L113.618 72.6059ZM113.618 70.7221L113.618 69.8021L97.8616 69.8021L97.8616 70.7221L113.618 70.7221ZM113.618 66.9983L113.618 67.9183L97.8616 67.9183L97.8616 66.0564L113.618 66.0564L113.618 66.9983Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6238 61.2359C13.6238 57.4278 16.7108 54.3408 20.5189 54.3408H115.41C119.218 54.3408 122.305 57.4278 122.305 61.2359V62.0171H13.6238V61.2359Z",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6235 102.392C13.6235 106.2 16.7106 109.287 20.5186 109.287H115.41C119.218 109.287 122.305 106.2 122.305 102.392V101.611H13.6235V102.392Z",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.8648,
    y1: 54.3407,
    x2: 89.8648,
    y2: 109.287,
    stroke: "#BFBFBF",
    strokeWidth: 1.37902,
    strokeDasharray: "5.17 5.17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4194,
    y: 71.7134,
    width: 29.0894,
    height: 4.0402,
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5911,
    y: 71.7134,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(90 50.5911 71.7134)",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5911,
    y: 79.7938,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(90 50.5911 79.7938)",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5911,
    y: 87.8742,
    width: 4.0402,
    height: 4.0402,
    transform: "rotate(90 50.5911 87.8742)",
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4194,
    y: 79.7938,
    width: 29.0894,
    height: 4.0402,
    fill: "#FB8400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4194,
    y: 87.8742,
    width: 29.0894,
    height: 4.0402,
    fill: "#FB8400"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 132.365C62.2367 132.365 62.8546 132.115 63.3538 131.616C63.853 131.117 64.1017 130.5 64.1 129.765C64.1 129.028 63.8504 128.41 63.3512 127.911C62.852 127.412 62.2349 127.163 61.5 127.165C60.7633 127.165 60.1454 127.414 59.6462 127.913C59.147 128.413 58.8983 129.03 58.9 129.765C58.9 130.501 59.1496 131.119 59.6488 131.618C60.148 132.118 60.7651 132.366 61.5 132.365ZM61.5 121.965C62.2367 121.965 62.8546 121.715 63.3538 121.216C63.853 120.717 64.1017 120.1 64.1 119.365V108.965C64.1 108.228 63.8504 107.61 63.3512 107.111C62.852 106.612 62.2349 106.363 61.5 106.365C60.7633 106.365 60.1454 106.614 59.6462 107.113C59.147 107.613 58.8983 108.23 58.9 108.965V119.365C58.9 120.101 59.1496 120.719 59.6488 121.218C60.148 121.718 60.7651 121.966 61.5 121.965ZM61.5 145.365C57.9033 145.365 54.5233 144.682 51.36 143.316C48.1967 141.95 45.445 140.098 43.105 137.76C40.765 135.42 38.9129 132.668 37.5488 129.505C36.1847 126.341 35.5017 122.961 35.5 119.365C35.5 115.768 36.1829 112.388 37.5488 109.225C38.9147 106.061 40.7667 103.31 43.105 100.97C45.445 98.6296 48.1967 96.7776 51.36 95.4134C54.5233 94.0493 57.9033 93.3664 61.5 93.3646C65.0967 93.3646 68.4767 94.0476 71.64 95.4134C74.8033 96.7793 77.555 98.6314 79.895 100.97C82.235 103.31 84.0879 106.061 85.4538 109.225C86.8197 112.388 87.5017 115.768 87.5 119.365C87.5 122.961 86.8171 126.341 85.4512 129.505C84.0853 132.668 82.2333 135.42 79.895 137.76C77.555 140.1 74.8033 141.953 71.64 143.318C68.4767 144.684 65.0967 145.366 61.5 145.365Z",
    fill: "#F16464"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 121.965C62.2367 121.965 62.8546 121.715 63.3538 121.216C63.853 120.717 64.1017 120.1 64.1 119.365V108.965C64.1 108.228 63.8504 107.61 63.3512 107.111C62.852 106.612 62.2349 106.363 61.5 106.365C60.7633 106.365 60.1454 106.614 59.6462 107.113C59.147 107.613 58.8983 108.23 58.9 108.965V119.365C58.9 120.101 59.1496 120.719 59.6488 121.218C60.148 121.718 60.7651 121.966 61.5 121.965Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 132.365C62.2367 132.365 62.8546 132.115 63.3538 131.616C63.853 131.117 64.1017 130.5 64.1 129.765C64.1 129.028 63.8504 128.41 63.3512 127.911C62.852 127.412 62.2349 127.163 61.5 127.165C60.7633 127.165 60.1454 127.414 59.6462 127.913C59.147 128.413 58.8983 129.03 58.9 129.765C58.9 130.501 59.1496 131.119 59.6488 131.618C60.148 132.118 60.7651 132.366 61.5 132.365Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_135_47299",
    x: 6.72844,
    y: 41.926,
    width: 122.472,
    height: 68.7369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5.51956
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.44755
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_135_47299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_135_47299",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_47299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2412,
    height: 24.2412,
    fill: "white",
    transform: "translate(34.438 52.5872) rotate(60)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAirError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/air-error.506ddcfb.svg";
export { ForwardRef as ReactComponent };